<script setup lang="ts">
const { showBanner, acceptCookies, declineCookies } = useCookieConsent()
</script>

<template>
  <Transition appear name="slide-up">
    <UDrawer
      v-model:open="showBanner"
      role="alert"
      aria-live="polite"
      inset
      :handle="false"
      class="z-50"
    >
      <template #body>
        <div class="space-y-2">
          <p>
            {{ $t('cookies.description') }}
          </p>
          <NuxtLink to="/privacy" class="text-primary underline">
            {{ $t('cookies.privacy_link') }}
          </NuxtLink>
        </div>
        <footer class="flex items-center justify-center gap-2 mt-4">
          <UButton
            variant="outline"
            color="neutral"
            :label="$t('cookies.decline')"
            size="lg"
            @click="declineCookies"
          />
          <UButton
            variant="solid"
            color="primary"
            size="lg"
            :label="$t('cookies.accept')"
            @click="acceptCookies"
          />
        </footer>
      </template>
    </UDrawer>
  </Transition>
</template>
